<form action='https://systempay.cyberpluspaiement.com/vads-payment/' method="post" #externalForm>
    <input type="hidden" *ngFor="let param of systempayVads; index as i" [value]="param.value" [name]="param.property">
    <input type="submit" (click)="sendData()" class="button button-orange" [value]="'cart.Pay_by_credit_card'|translate">
</form>
<p *ngIf="action == 'REGISTER_SUBSCRIBE' || action == 'REGISTER_PAY_SUBSCRIBE'">
    {{ 'cart.Will_be_renewed'|translate }}
</p>